import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";
import { getVacations, createVacation, deleteVacation } from "../api";
import {formatDateDE} from "../utils";

export default function Vacations() {
    const { token } = useContext(AuthContext);
    const [vacations, setVacations] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [status, setStatus] = useState("");

    const load = () => {
        getVacations()
            .then(setVacations)
            .catch(() => setVacations([]));
    };

    useEffect(() => { load(); }, []);

    const submit = async (e) => {
        e.preventDefault();
        try {
            await createVacation(token, { startDate, endDate });
            setStatus("Gespeichert");
            setStartDate("");
            setEndDate("");
            load();
        } catch (e) {
            setStatus("Fehler beim Speichern");
        }
    };

    const remove = async (id) => {
        try {
            await deleteVacation(token, id);
            load();
        } catch (e) {
            setStatus("Fehler beim Löschen");
        }
    };

    return (
        <div className="p-4 max-w-xl mx-auto">
            <h2 className="text-2xl mb-4">Urlaub hinzufügen</h2>
            <form onSubmit={submit} className="flex flex-col gap-4 mb-8">
                <input
                    type="date"
                    value={startDate}
                    onChange={e => setStartDate(e.target.value)}
                    className="border p-2"
                    required
                />
                <input
                    type="date"
                    value={endDate}
                    onChange={e => setEndDate(e.target.value)}
                    className="border p-2"
                    required
                />
                <button className="bg-blue-600 text-white py-2" type="submit">Speichern</button>
                {status && <p>{status}</p>}
            </form>

            <h2 className="text-2xl mb-4">Geplante Urlaube</h2>
            <table className="w-full border">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="p-2">Von</th>
                        <th className="p-2">Bis</th>
                        <th className="p-2">Aktion</th>
                    </tr>
                </thead>
                <tbody>
                    {vacations.map(v => (
                        <tr key={v.id} className="border-t">
                            <td className="p-2">{formatDateDE(v.startDate)}</td>
                            <td className="p-2">{formatDateDE(v.endDate)}</td>
                            <td className="p-2 text-center">
                                <button
                                    className="bg-red-600 text-white px-2 py-1"
                                    onClick={() => remove(v.id)}
                                >
                                    Löschen
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

